import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Absolute } from 'rebass';
import { FONT_SIZE } from '@tcaster/tcaster-theme';

import Chart from '../Chart';
import { Text, Number as BaseNumber } from '../Base';
import { getFormattedNumber, getNumberVariant } from '../Base/Number';
import { SPACE } from '../Theme';

import { Table, TableCell as BaseTableCell, TableBody, TableRow } from './TableComponents';

// const TableCell = React.cloneElement(BaseTableCell, { cellBorder: true });
const TableCell = props => <BaseTableCell cellBorder {...props} />;
const Number = props => <BaseNumber numSize="large" alignItems="center" {...props} />;

const MUI_TABLE_PADDING_X = 24;

const isPositiveOrZero = diff => diff >= 0;

const getChartColor = variant => {
  let color, activeColor;
  switch (variant) {
    case 'blue':
      color = '#9ec6ea';
      break;

    case 'red':
    default:
      color = '#ffb1b2';
      activeColor = '#ff5855';
      break;
  }
  return { color, activeColor };
};

const ScoreStats = ({ score, max, min, avg, sd, scoreVariant }) => {
  const isPositiveDiff = isPositiveOrZero(score - avg);
  const numVariant = getNumberVariant(scoreVariant);
  const diff = getFormattedNumber(Math.abs(score - avg), numVariant);
  // const diffDisplay = isPositiveDiff ? `+${diff}` : diff;
  const diffLabelDisplay = isPositiveDiff ? 'สูงกว่าเฉลี่ย' : 'ต่ำกว่าเฉลี่ย';
  return (
    <Flex flexDirection="column" justifyContent="space-between">
      <Box>
        <Number label="คะแนนสูงสุด" value={max} variant={numVariant} />
        <Number label="คะแนนต่ำสุด " value={min} variant={numVariant} />
        <Number label="คะแนนเฉลี่ย" value={avg} variant={numVariant} />
        <Number label="SD" value={sd} variant={numVariant} />
      </Box>
      <Absolute bottom={SPACE.medium} left={MUI_TABLE_PADDING_X} right={MUI_TABLE_PADDING_X}>
        {score && (
          <Fragment>
            <Text fontWeight="bold">เปรียบเทียบคะแนน</Text>
            <Flex py={2} justifyContent="space-between" alignItems="center">
              <Text>{diffLabelDisplay}</Text>
              <Text
                color={isPositiveDiff ? 'secondary' : 'danger'}
                ml={2}
                fontSize={FONT_SIZE.semilarge}
              >
                {diff}
              </Text>
            </Flex>
          </Fragment>
        )}
      </Absolute>
    </Flex>
  );
};

class RankingChartTable extends Component {
  static propTypes = {
    chartData: PropTypes.array,
    score: PropTypes.number,
    fullScore: PropTypes.number,
    chartVariant: PropTypes.oneOf(['red', 'blue']),
    isPercentValue: PropTypes.bool,
    xLabel: PropTypes.string,
    yLabel: PropTypes.string,
  };

  static defaultProps = {
    chartVariant: 'red',
  };

  render() {
    const {
      title,
      chartData,
      score,
      fullScore,
      max,
      min,
      avg,
      sd,
      rank,
      totalRank,
      chartVariant,
      isPercentValue,
      xLabel,
      yLabel,
      scoreVariant,
    } = this.props;
    const { color, activeColor } = getChartColor(chartVariant);
    const totalRankProps = {
      value: totalRank,
      is: 'span',
      alignItems: 'baseline',
      py: 0,
    };
    return (
      <Box mb={SPACE.medium}>
        <Text.Subtitle mb={SPACE.medium}>{title}</Text.Subtitle>
        <Box style={{ overflowX: 'auto' }}>
          <Table border padding="dense">
            <TableBody>
              <TableRow height="42px">
                <TableCell>
                  {rank && (
                    <Flex alignItems="baseline">
                      <Number
                        label="คุณได้ลำดับที่"
                        value={rank}
                        is="span"
                        alignItems="baseline"
                        py={0}
                      />
                      <Number {...totalRankProps} label="จากจำนวนผู้เข้าสอบ" ml={SPACE.small} />
                      <Text fontWeight="bold" is="span" ml={SPACE.small}>
                        คน
                      </Text>
                    </Flex>
                  )}
                  {!rank && totalRank && (
                    <Flex alignItems="baseline">
                      <Number {...totalRankProps} label="จำนวนผู้เข้าสอบทั้งหมด" />
                      <Text fontWeight="bold" is="span" ml={SPACE.small}>
                        คน
                      </Text>
                    </Flex>
                  )}
                </TableCell>
                <TableCell>
                  <Text fontWeight="bold">ข้อมูลคะแนน</Text>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Chart
                    data={chartData}
                    score={score}
                    fullScore={fullScore}
                    color={color}
                    activeColor={activeColor}
                    isPercentValue={isPercentValue}
                    xLabel={xLabel}
                    yLabel={yLabel}
                  />
                </TableCell>
                <TableCell style={{ verticalAlign: 'top' }}>
                  <ScoreStats scoreVariant={scoreVariant} {...{ score, max, min, avg, sd }} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    );
  }
}

export default RankingChartTable;
